import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-lg">
                <div className="text-center">
                    <XCircle className="mx-auto h-16 w-16 text-yellow-500" />
                    <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                        Payment Cancelled
                    </h2>
                    <p className="mt-2 text-sm text-gray-600">
                        You cancelled the payment process. Your booking request has been saved.
                    </p>
                </div>

                <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-md p-4">
                    <p className="text-sm text-yellow-800">
                        Don't worry! Your booking details have been saved and one of our travel advisors will contact you to complete the booking.
                    </p>
                </div>

                <div className="mt-8 space-y-3">
                    <div className="text-center">
                        <p className="text-sm font-semibold text-gray-900">
                            Want to complete your booking now?
                        </p>
                        <p className="text-lg font-bold text-secondary">
                            Call: 03338820922
                        </p>
                        <p className="text-sm text-gray-600 mt-2">
                            or WhatsApp: +923338820922
                        </p>
                    </div>
                </div>

                <div className="mt-8 space-y-3">
                    <button
                        onClick={() => navigate('/flight-detail-search')}
                        className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-secondary hover:bg-navy-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
                    >
                        Search Flights Again
                    </button>
                    <button
                        onClick={() => navigate('/')}
                        className="w-full flex justify-center py-3 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
                    >
                        Return to Home
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentCancel;
